import { render, staticRenderFns } from "./UIAddBuilding.vue?vue&type=template&id=2b860f0e&"
import script from "./UIAddBuilding.vue?vue&type=script&lang=js&"
export * from "./UIAddBuilding.vue?vue&type=script&lang=js&"
import style0 from "./UIAddBuilding.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports